export default {
  999: { label: '기타' },
  999999: { label: '기타' },
  '001': { label: '회원' },
  '001001': {
    label: '회원가입',
    inclusion: ['회원가입 완료안내, 가입축하 적립금 및 쿠폰 템플릿'],
    exclusion: [
      '상품 또는 서비스 가입 관련 템플릿은 "구매 > 상품가입” 카테고리를 선택하세요.',
    ],
  },
  '001002': {
    label: '인증/비밀번호/로그인',
    inclusion: ['OTP, 로그인 여부, 임시 비밀번호, 본인 확인 템플릿'],
  },
  '001003': {
    label: '회원정보/회원혜택',
    inclusion: ['회원 등급 안내, 혜택 안내, 생일/기념일 축하 템플릿'],
  },
  '002': { label: '구매' },
  '002001': {
    label: '구매완료',
    inclusion: ['주문 완료, 구매 완료 템플릿'],
    exclusion: [
      '일정 관련 예약 및 예약번호가 포함된 템플릿은 “예약” 카테고리를 선택하세요.',
    ],
  },
  '002002': {
    label: '상품가입',
    inclusion: [
      '상품 가입/계약 완료, 서비스 가입 완료, 정기 결제 상품, 렌탈 가입 등 정기 결제 관련 상품/서비스 가입 템플릿',
    ],
    exclusion: [
      '회원 가입 관련 템플릿은 “회원 > 회원가입” 카테고리를 선택하세요.',
    ],
  },
  '002004': {
    label: '구매취소',
    inclusion: [
      '품절, 환불, 상품 해지, 서비스 가입 해지, 렌탈 해지 등 상품 구매 의사나 판매 상태 중지에 따른 구매 취소 템플릿',
    ],
  },
  '002005': {
    label: '구매예약/입고알림',
    inclusion: ['입고 알림 예약, 사전 구매 템플릿'],
  },
  '003': { label: '예약' },
  '003001': {
    label: '예약완료/예약내역',
    inclusion: [
      '예약 완료 확인 (예약 내역, 예매 완료, 서비스/진료 예약, 대관 예약, 상담 예약, 예약 결제 완료) 템플릿',
    ],
    exclusion: [
      '예약 상태 확인 (예약 변경, 예약 확정, 입금 대기, 발권 완료, 사용 완료, 예약 대기, 스케줄 변경, 예약 확인, 좌석 배정 완료, 모바일 체크인 등) 템플릿',
      '예약한 서비스의 이용 안내는 “서비스 이용 > 이용 안내” 카테고리를 선택하세요.',
    ],
  },
  '003003': {
    label: '예약취소',
    inclusion: ['예약 실패, 취소 등 예약 미진행 템플릿'],
  },
  '009': { label: '쿠폰/포인트' },
  '009001': {
    label: '쿠폰발급',
    inclusion: ['서비스/상품을 무료 또는 할인하는 쿠폰 발급 템플릿'],
    exclusion: [
      '구매 과정에서 제공되는 교환권, 예매권, 티켓 등은 대상이 아닙니다.',
      '쿠폰 소멸 예정 알림, 이용 안내 등의 알림톡은 “쿠폰/포인트안내” 카테고리를 선택하세요.',
    ],
  },
  '009002': {
    label: '쿠폰사용',
    inclusion: [
      '무료 또는 할인 제공 목적으로 발급된 쿠폰의 사용 완료 알림 템플릿',
    ],
    exclusion: [
      '구매 과정에서 제공되는 교환권, 예매권, 티켓 등은 대상이 아닙니다.',
      '쿠폰 소멸 예정 알림, 이용 안내 등의 알림톡은 “쿠폰/포인트안내” 카테고리를 선택하세요.',
    ],
  },
  '009003': {
    label: '포인트적립',
    inclusion: [
      '포인트, 마일리지, 적립금 등 고객 리워드 적립 완료 템플릿',
    ],
    exclusion: [
      '적립방법, 이용기한 등의 안내는 “쿠폰/포인트안내” 카테고리를 선택하세요.',
    ],
  },
  '009004': {
    label: '포인트사용',
    inclusion: [
      '포인트, 마일리지, 적립금 등 고객 리워드 사용 결과 템플릿',
    ],
    exclusion: [
      '적립방법, 이용기한 등의 안내는 “쿠폰/포인트안내” 카테고리를 선택하세요.',
    ],
  },
  '009005': {
    label: '쿠폰/포인트안내',
    inclusion: [
      '쿠폰, 포인트, 적립금, 마일리지 등의 이용 안내, 소멸 예정, 정책 변경, 이용 기한 안내 등의 템플릿',
    ],
  },
  '005': { label: '리포팅' },
  '005001': {
    label: '피드백',
    inclusion: [
      '고객 문의 답변, 출결 및 온/오프 상태 피드백, 처리 결과 피드백, 출결 확인, 보안 해제, 이벤트 당첨 결과 안내 등의 템플릿',
    ],
  },
  '005002': {
    label: '요금청구',
    inclusion: [
      '청구서, 결제 예정 안내, 청구 예정 금액 안내, 영수증, 세금계산서, 거래 명세서 등 요금 청구와 관련된 템플릿',
    ],
    exclusion: [
      '이자 납입, 보험료 청구 등 금융과 관련된 요금 청구는 “기타” 카테고리를 선택하세요.',
    ],
  },
  '005003': {
    label: '계약/견적',
    inclusion: ['계약서, 견적서, 계약 서명 요청 등의 템플릿'],
  },
  '005004': {
    label: '안전/피해예방',
    inclusion: [
      '보이스피싱 방지, 사기 예방, 날씨 등 천재지변에 따른 피해 예방과 관련된 템플릿',
    ],
  },
  '005005': {
    label: '뉴스레터',
    inclusion: [
      '새로운 소식/정보를 알리기 위해 구성원에게 정기적으로 보내는 내용의 템플릿',
    ],
  },
  '005006': {
    label: '거래알림',
    inclusion: [
      '금융기관 (은행, 증권사, 카드사 등) 또는 결제업체에서 사용자에게 거래 진행 상태와 결과 안내를 위한 템플릿',
    ],
  },
  '006': { label: '배송' },
  '006001': {
    label: '배송상태',
    inclusion: ['배송, 통관, 회수 진행 상태 템플릿'],
    exclusion: ['배달 예정, 방문 예정, 회수 예정 등의 템플릿'],
  },
  '006003': {
    label: '배송완료',
    inclusion: ['배달 완료, 회수 완료 템플릿'],
  },
  '004': { label: '서비스이용' },
  '004001': {
    label: '이용안내/공지',
    inclusion: [
      '발급 안내, 사용 안내, 변동 사항 공지, 이용 중인 서비스의 상태 알림 등 이용과 관련한 안내 및 공지사항 템플릿',
    ],
  },
  '004002': {
    label: '신청접수',
    inclusion: [
      '(구매/예약이 아닌) 이용 신청, 발급 신청, 수강 신청, 입소 신청, 서비스 해지 신청, 이벤트 응모, 자격 신청 등의 접수/해지 관련 템플릿',
    ],
  },
  '004003': {
    label: '처리완료',
    inclusion: ['주문 처리 완료, 주문 완료 등의 템플릿'],
  },
  '004004': {
    label: '이용도구',
    inclusion: [
      '모바일 탑승권, 티켓, QR 코드 등 서비스 이용/입장 등 이용 자격 증명에 활용할 수 있는 템플릿',
    ],
    exclusion: [
      '관련 발급 안내 사항은 “서비스 이용 > 이용 안내” 카테고리를 선택하세요.',
    ],
  },
  '004005': {
    label: '방문서비스',
    inclusion: ['렌탈 제품 케어 방문 예정 등의 템플릿'],
    exclusion: [
      '렌탈 계약 관련 템플릿은 “구매 > 상품 가입” 카테고리를 선택하세요.',
    ],
  },
  '004006': {
    label: '피드백 요청',
    inclusion: [
      '수신자 참여 독려 (만족도 조사, 설문 조사 참여 요청, 리뷰 작성 요청 등) 템플릿',
    ],
  },
  '004007': {
    label: '구매감사/이용확인',
    inclusion: ['이용 감사 인사, 이용 확인 템플릿'],
  },
  '004008': {
    label: '리마인드',
    inclusion: [
      '순서 알림, 일자 도래 안내, 배차 알림, 예약 종료 알림, 도서 대출 기간 만료 알림 등의 템플릿',
    ],
  },
  '007': { label: '법적고지' },
  '007001': {
    label: '수신동의',
    inclusion: ['마케팅 수신 동의, 광고성 정보 수신 동의 등의 템플릿'],
  },
  '007002': {
    label: '개인정보',
    inclusion: [
      '개인정보 제공 동의, 개인정보 수집 출처, 개인정보 처리 위탁 등 개인정보 보호법 관련 개인정보 수집/동의에 대한 안내 템플릿',
    ],
  },
  '007003': {
    label: '약관변경',
    inclusion: [
      '이용 약관, 회원 약관 등 약관 변경 사항 고지에 관한 템플릿',
    ],
  },
  '007004': {
    label: '휴면 관련',
    inclusion: [
      '장기 미사용 등의 사유로 정보통신망법에 따른 휴면 계정 전환 예정/처리 고지 관련 템플릿',
    ],
  },
  '008': { label: '업무알림' },
  '008001': {
    label: '주문/예약',
    inclusion: ['사업장으로 인입된 주문/예약 관련 템플릿 (취소 포함)'],
  },
  '008002': {
    label: '내부 업무 알림',
    inclusion: [
      '소속 구성원 또는 관련 업무자들에게 업무 또는 내부 관리 용도로 전달되는 알림톡',
    ],
  },
};
